import { Component } from '@angular/core';

@Component({
  selector: 'app-spinner-th',
  templateUrl: './spinner-th.component.html',
  styleUrls: ['./spinner-th.component.css']
})
export class SpinnerTHComponent {}
